var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { useAuthWithConfig } from "../hooks/useAuthWithConfig";
export var AuthGuardWithConfig = function (_a) {
    var config = _a.config, children = _a.children, _b = _a.requiredPermissions, requiredPermissions = _b === void 0 ? [] : _b, _c = _a.fallback, fallback = _c === void 0 ? _jsx("div", { children: "\u52A0\u8F7D\u4E2D..." }) : _c, _d = _a.fallbackMessage, fallbackMessage = _d === void 0 ? "您没有访问此页面的权限" : _d;
    var _e = useAuthWithConfig(config), isAuthenticated = _e.isAuthenticated, loading = _e.loading, error = _e.error, hasAnyPermission = _e.hasAnyPermission, user = _e.user;
    var isBrowser = typeof window !== "undefined";
    var isEmbedded = isBrowser && window.parent !== window;
    /**
     * 已移除自动 MS_EMBED_NEED_LOGIN：父页（未升级的 msLogin）收到后会 location.assign，
     * 整页刷新 → iframe 再加载 → 再次发消息 → 死循环。仅部署 CRM PC 时父站往往未更新。
     * 令牌依赖父页 IframeRenderer + TOKEN_UPDATE_REQUEST；需整页登录时请用户从工作台重进或单独打开 CRM。
     */
    var cachedUser = typeof window !== "undefined" ? localStorage.getItem("mslogin_user") : null;
    var cachedToken = typeof window !== "undefined"
        ? localStorage.getItem(config.tokenKey) ||
            sessionStorage.getItem(config.tokenKey) ||
            localStorage.getItem("mslogin_token") ||
            sessionStorage.getItem("mslogin_token")
        : null;
    var hasCache = !!(cachedUser && cachedToken);
    if (error) {
        return (_jsxs("div", __assign({ style: { padding: "20px", textAlign: "center" } }, { children: [_jsx("h3", { children: "\u8BA4\u8BC1\u9519\u8BEF" }), _jsx("p", { children: error }), _jsx("button", __assign({ onClick: function () {
                        // 不刷新页面，而是重新进行认证检查
                        // window.location.reload();
                    } }, { children: "\u91CD\u8BD5" }))] })));
    }
    // 独立打开微前端：保留「有缓存则先渲染 + loading 时用 fallback」
    if (!isEmbedded) {
        if (loading && hasCache) {
            return _jsx(_Fragment, { children: children });
        }
        if (loading && !hasCache) {
            return _jsx(_Fragment, { children: fallback });
        }
    }
    if (!isAuthenticated) {
        if (isEmbedded) {
            // iframe 内统一一块占位，避免「fallback / 等待验证 / 内容」之间来回切换造成乱闪
            return (_jsx("div", __assign({ style: {
                    padding: 48,
                    textAlign: "center",
                    fontFamily: "system-ui, sans-serif",
                    color: "#666",
                } }, { children: _jsx("p", __assign({ style: { margin: 0, fontSize: 15 } }, { children: cachedToken ? "正在验证登录…" : "正在连接主系统…" })) })));
        }
        else if (isBrowser) {
            var currentUrl = window.location.href;
            var msOrigin = String(config.msLoginUrl || "").replace(/\/$/, "");
            var loginPath = String(config.loginUrl || "/login");
            var loginBase = msOrigin + (loginPath.startsWith("/") ? loginPath : "/".concat(loginPath));
            var loginUrl = "".concat(loginBase, "?returnUrl=").concat(encodeURIComponent(currentUrl));
            window.location.href = loginUrl;
        }
        return (_jsxs("div", __assign({ style: { padding: "20px", textAlign: "center" } }, { children: [_jsx("h3", { children: "\u9700\u8981\u767B\u5F55" }), _jsx("p", { children: "\u8BF7\u7A0D\u5019\uFF0C\u6B63\u5728\u5904\u7406\u767B\u5F55\u6D41\u7A0B..." })] })));
    }
    // 检查权限
    if (requiredPermissions.length > 0 &&
        !hasAnyPermission(requiredPermissions)) {
        // 添加调试信息
        console.log('[AuthGuardWithConfig] 权限检查失败:', {
            requiredPermissions: requiredPermissions,
            userPermissions: (user === null || user === void 0 ? void 0 : user.permissions) || [],
            userRoles: (user === null || user === void 0 ? void 0 : user.roles) || [],
            isSuperAdmin: user === null || user === void 0 ? void 0 : user.isSuperAdmin,
            hasAnyPermissionResult: hasAnyPermission(requiredPermissions),
        });
        return (_jsxs("div", __assign({ style: { padding: "20px", textAlign: "center" } }, { children: [_jsx("h3", { children: "\u6743\u9650\u4E0D\u8DB3" }), _jsx("p", { children: fallbackMessage }), _jsxs("p", { children: ["\u5F53\u524D\u7528\u6237: ", (user === null || user === void 0 ? void 0 : user.account) || "未知"] }), _jsxs("p", { children: ["\u6240\u9700\u6743\u9650: ", requiredPermissions.join(", ")] }), _jsxs("p", { children: ["\u7528\u6237\u6743\u9650: ", ((user === null || user === void 0 ? void 0 : user.permissions) || []).join(", ") || "无"] }), _jsxs("p", { children: ["\u7528\u6237\u89D2\u8272: ", ((user === null || user === void 0 ? void 0 : user.roles) || []).join(", ") || "无"] }), _jsxs("p", { children: ["\u662F\u5426\u8D85\u7EA7\u7BA1\u7406\u5458: ", (user === null || user === void 0 ? void 0 : user.isSuperAdmin) ? "是" : "否"] })] })));
    }
    return _jsx(_Fragment, { children: children });
};
